import React, { Fragment, Component } from "react";
import { FormGroup, Row, Col, Label, Input } from "reactstrap";
import Autosuggest from "../../../../Autosuggest/Autosuggest";
import styleF from "../Field.module.scss";
import { CircularProgress } from "../../../..";
import Holders from "./Holders";
import Instruction from "./Instruction";
import { clientPrice, commissionSuffix } from "../../Form/commons";
import {
  OrderPriceType,
  getCommissionItems,
  ProductType,
  OrderStatus,
  CommissionType as ComType,
  getBaseAndPriceCurrencies,
} from "../../../../../utils/Order/Order";
import { Field, Numeric, Combobox, Switch } from "../Field";
import QuantityHelper from "../../Helper/QuantityHelper";
import EarningsHelper from "../../Helper/EarningsHelper";
import Balance from "./Balance";
import { UserType } from "../../../../../utils/Helper";
import { Dispatch as Context } from "../../store/store";
import { formattedNumber } from "../../../../FormattedNumber/FormattedNumber";
import { ExternalAccountWrapper } from "./ExternalAccountsWrapper";
import { CheckFormField } from "../../../../../utils";

class Account extends Component {
  constructor(props) {
    super(props);
    const { account, balanceReady, opsViewAccountName } = props;
    const { AccountId } = account;
    Account.contextType = Context;

    this.state = {
      loadingHolders: AccountId != null,
      loadingBalance: AccountId != null && balanceReady,
      holders: null,
      balance: null,
      instructions: null,
      sendingMail: false,
      clientBankAccounts: [],
      selectedBankAccount: null,
      useCashAccount: false,
      accountIsJuridical: false,
      ownPositionAccounts: [],
    };
  }
  
  // componentWillMount() {
  //   const { account } = this.props;
  //   const { AccountId } = account;

  //   if (AccountId != null) {
  //     this.requestAccountInfo();
  //     this.requestAccountHolders({ accountId: AccountId });
  //   }
  // }
  

  componentDidMount() {
    this._isMounted = true;
    const { account, userType, platformRole } = this.props;
    const { AccountId, AccountName, AccountNumber, HolderId } = account;

    if (AccountId != null) {
      this.requestAccountInfo({}, false);
      this.requestAccountHolders({ accountId: AccountId });
    }

    if (platformRole == "Trader" || platformRole == "BackOffice" || platformRole == "MiddleOffice") {
      this.props.fetchOwnPositionAccounts().then(({ accounts }) => {
        this.setState({ ownPositionAccounts: accounts });
      });
    }

    // Cuando se ve una orden ya viene precargados los valores
    if (!isEmpty(AccountId) && isEmpty(HolderId)) {
      this.onChange("", {
        id: AccountId,
        name: AccountName,
        number: AccountNumber,
      });
    }
  }

  componentDidUpdate(prevProps) {
    const { account, balanceReady, updateAccount, order } = this.props;
    const { AccountId, HolderId, clientBankAccount } = account;
    // Caso especifico cuando se elige el ticker del selector
    if ((balanceReady && !prevProps.balanceReady && AccountId) || prevProps.updateAccount != updateAccount) {
      this.requestAccountInfo({}, true);
    }
    // if (
    //   (this.props.getUserExternalAccounts &&
    //     HolderId &&
    //     prevProps.account &&
    //     (prevProps.account.HolderId !== HolderId ||
    //       (order.AssetId && prevProps.order.AssetId !== order.AssetId))) ||
    //   order.OrderSide !== prevProps.order.OrderSide
    // ) {
    //   this.props
    //     .getUserExternalAccounts({ personId: HolderId, accountId: AccountId })
    //     .then((res) => {
    //       const { clientBankAccounts } = res.response;
    //       if (clientBankAccounts.length > 0) {
    //         const filteredAccounts = clientBankAccounts.filter(
    //           (accounts) => accounts.currencyISO === order.OrderCurrencySymbol
    //         );
    //         this.props.onChange({
    //           clientBankAccounts: filteredAccounts,
    //           clientBankAccount: null,
    //           useCashAccount: false,
    //         });
    //       } else {
    //         this.props.onChange({ clientBankAccounts: [], clientBankAccount: null, useCashAccount: false });
    //       }
    //     })
    //     .catch((e) => console.error(e));
    // } else {
    //   if (order.OrderAssetData && order.CurrentAccount.useCashAccount) {
    //     this.props.onChange({ clientBankAccount: null, useCashAccount: false });
    //   }
    // }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  onSuggestionsFetchRequested = ({ value }) =>
    this.props.searchAccount({ text: value }).then((response) =>
      response.response.accounts.map((a) => {
        const accountAttrs = JSON.parse(a.Value);
        return {
          id: a.Id,
          name: accountAttrs.value,
          number: accountAttrs.key,
        };
      })
    );

  onChangeAccountHolder = (value) => {
    const holderItem = getItemById(this.state.holders, value);

    let currentInstruction = -1;
    if (this.props.order.CurrentAccount) {
      currentInstruction = this.props.order.CurrentAccount.Instruction;
      if (holderItem.instructions.find((ins) => ins.id == currentInstruction) === undefined) {
        // If the current instruction is not available to the new holder,
        // select the first instruction available to the holder.
        currentInstruction = holderItem.instructions[0].id;
      }
    }

    this.setState({
      instructions: holderItem.instructions,
      accountIsJuridical: holderItem.HolderIsJuridical,
      isMainHolder: holderItem.isMain,
    });

    this.props.onChange({
      HolderId: holderItem.id,
      HolderName: holderItem.description,
      Instruction: currentInstruction,
    });
    //
  };

  onChangeInstruction = (value) => {
    const instructionItem = getItemById(this.state.instructions, value);

    this.props.onChange({
      Instruction: instructionItem.id,
    });
  };

  requestAccountInfo = (body, updateOrderValues) => {
    if (this.props.balanceReady) {
      const assetTicker =
        this.props.order.AssetClassForm === ProductType.REPO &&
        this.props.order.CurrentAccount.Collateral &&
        this.props.order.CurrentAccount.Collateral.length
          ? this.props.order.CurrentAccount.Collateral[0].AssetTicker
          : this.props.order.AssetTicker;

      this.setState({ loadingBalance: true });

      this.props.accountInfo({ ...body }, updateOrderValues).then((response) => {
        const { balance, accountInfo, balanceWithBooktype } = response.response.accountorderdata;
        const { AccountAsksCustody, AccountType, AccountInBalanceType, AccountUseMarkUP } = accountInfo;

        const assetBalanceItem = balance.find((item) => item.key == assetTicker);
        const assetBalance = assetBalanceItem ? parseFloat(assetBalanceItem.value) : 0.0;

        let modsOnAccount = {
          AccountAsksCustody,
          AccountType,
          AccountInBalanceType,
          AccountAssetBalance: assetBalance,
          AccountUseMarkUP,
        };
        if (AccountAsksCustody) {
          modsOnAccount.RequiresSpecialCustody = true;
        }

        if (this._isMounted) {
          this.setState({
            balance: balanceWithBooktype ? balanceWithBooktype : balance,
            loadingBalance: false,
          });
          this.props.onChange(modsOnAccount);
        }
      });
    }
  };

  requestAccountHolders = ({ accountId }) => {
    this.props.accountHolders({ accountId }).then((response) => {
      const { holders } = response.response;
      const _holders = holders
        .filter((h) => h.HoldersOrderNO || h.HoldersOrderW || h.HoldersOrderV || h.HoldersOrderL)
        .map((h) => ({
          isMain: h.IsMain,
          description: h.PersonName,
          instructions: getInstructions(h, this.props.order.OrderIsBasket),
          id: h.PersonId,
          isJuridical: h.HolderIsJuridical,
        }));

      let selectedHolder = _holders.find((h) => h.isMain) || (_holders.length ? _holders[0] : null);

      if (this.props.order.CurrentAccount && this.props.order.CurrentAccount.HolderId > 0) {
        selectedHolder = _holders.find((h) => h.id == this.props.order.CurrentAccount.HolderId);
        if (selectedHolder === undefined) {
          selectedHolder = null;
        }
      }

      this._isMounted &&
        this.setState(
          {
            holders: _holders,
            loadingHolders: false,
            instructions: selectedHolder && selectedHolder.instructions,
            accountIsJuridical: selectedHolder && selectedHolder.isJuridical,
            isMainHolder: selectedHolder && selectedHolder.isMain,
          },
          () => {
            const { account } = this.props;
            const { HolderId } = account;

            if (HolderId == null && selectedHolder) {
              const { id, description, instructions } = selectedHolder;

              const instruction = instructions && instructions.length ? instructions[0] : null;

              this.props.onChange({
                HolderId: id,
                HolderName: description,
                Instruction: instruction ? instruction.description : null,
              });
            }
          }
        );
    });
  };

  onChange = (method, value) => {
    let _value = defaultAccountValue;

    if (method != "type" && value.id) {
      _value = {
        AccountNumber: value.number,
        AccountName: value.name,
        AccountId: value.id,
      };

      this.requestAccountInfo(_value, true);
      this.requestAccountHolders({ accountId: value.id });
      this.setState({
        holders: null,
        balance: null,
        loadingHolders: true,
      });
    } else {
      this.setState({
        holders: null,
        balance: null,
        instructions: null,
      });
      _value.AccountName = value;
    }

    this.props.onChange(_value);
  };

  onSetAttachment = (file) => {
    const { dispatch, account } = this.props;
    const { AccountId } = account;
    dispatch({ type: "SET_ATTACHMENT", payload: { id: AccountId, file } });
  };

  onResendAuth = (orderId, accountId) => {
    this.setState({ sendingMail: true });
    this.props.resendAuth(orderId, accountId);
    setTimeout(() => {
      this.setState({ sendingMail: false });
    }, 1000);
  };

  onSelectedAccountChange = (accountNumber) => {
    const changes = { clientBankAccount: accountNumber };
    if (this.props.order.OrderSide === "Sell" && accountNumber) {
      changes.useCashAccount = false;
    }
    this.props.onChange(changes);
  };

  onCheckCashAccount = (evt) => {
    const changes = { useCashAccount: !!!this.props.order.CurrentAccount.useCashAccount };
    if (this.props.order.OrderSide === "Sell") {
      changes.clientBankAccount = null;
    }
    this.props.onChange(changes);
  };

  onChangeAvailableAccounts = (accounts) => {
    const changes = { clientBankAccounts: accounts };
    this.props.onChange(changes);
  }
  
  render() {
    const {
      order,
      account,
      readonly,
      hiddens,
      errors,
      balanceReady,
      attachContent,
      downloadAttachment,
      orderPdf,
      attachmentDisabled,
      hasAttachment,
      onChange,
      onChangeOrder,
      userType,
      imgSource,
      opsViewAccountName
    } = this.props;

    const {
      AccountId,
      AccountName,
      AccountNumber,
      AccountType,
      HolderId,
      HolderName,
      Quantity,
      AccountAsksCustody,
      RequiresSpecialCustody,
      AccountUseMarkUP,
      Markup,
      MarkupType,
      FXMarkup,
      FXMarkupType,
      Commission,
      CommissionType,
      CurrentInfoDate,
      clientBankAccounts,
      clientBankAccount,
      useCashAccount,
      differCommissionPayment,
      Advice,
    } = order.CurrentAccount;
    const {
      OrderId,
      OrderSide,
      AssetClassForm,
      AssetPriceIsDiscounted,
      OrderCurrencySymbol,
      OrderSettlementCurrencySymbol,
      AssetCanBeSelfCustodied,
      OrderQuantityIsCash,
      SubAssetClassDecimalPlaces,
      OrderAllowsMarkup,
      OrderTerm,
      OrderAssetData,
    } = order;
    const { state: contextState } = this.context;
    const { entities: contextEntities } = contextState;
    const { settlementCurrencies } = contextEntities;

    let showBankAccounts = true;
    if (OrderAssetData && OrderAssetData.items["FundX"]) {
      showBankAccounts = false;
    }

    const { baseCurrency, priceCurrency } = getBaseAndPriceCurrencies(
      settlementCurrencies,
      OrderCurrencySymbol,
      OrderSettlementCurrencySymbol
    );

    let custodyHidden = false;
    let markupHidden = false;
    let FXMarkupHidden = false;
    let commissionHidden = false;
    let custodyReadonly = false;
    let commissionPaymentHidden = false;
    if (
      (!AccountType && userType === UserType.Trader) ||
      (AccountType && AccountType.toLowerCase() !== "customer")
    ) {
      custodyHidden = true;
      markupHidden = true;
      FXMarkupHidden = true;
      commissionHidden = true;
      commissionPaymentHidden = true;
    } else {
      switch (AssetClassForm) {
        case ProductType.FOREX:
          markupHidden = true;
          FXMarkupHidden = true;
          commissionHidden = true;
          commissionPaymentHidden = true;
          break;
        case ProductType.MMARKET:
          FXMarkupHidden = true;
          break;
        default:
          break;
      }
      if (!OrderSettlementCurrencySymbol || OrderCurrencySymbol == OrderSettlementCurrencySymbol) {
        FXMarkupHidden = true;
      }
      if (OrderSide == "Buy" && AssetCanBeSelfCustodied) {
        custodyHidden = false;
        if (AccountAsksCustody) {
          custodyReadonly = true;
        }
      } else {
        custodyHidden = true;
      }
    }

    if (
      (OrderId && OrderAllowsMarkup === false) ||
      AccountUseMarkUP === false ||
      [ProductType.REPO, ProductType.FUTURE].includes(AssetClassForm)
    ) {
      markupHidden = true;
      FXMarkupHidden = true;
    }

    const modHiddens = {
      ...hiddens,
      RequiresSpecialCustody: custodyHidden,
      Markup: markupHidden,
      MarkupType: markupHidden,
      FXMarkup: FXMarkupHidden,
      FXMarkupType: FXMarkupHidden,
      Commission: commissionHidden,
      CommissionType: commissionHidden,
      DifferCommissionPayment: commissionPaymentHidden,
    };

    const currentDayData = account.Day ? account.Day.find((day) => day.Date === CurrentInfoDate) : undefined;

    const currentDay = currentDayData
      ? {
          AssignedQty: currentDayData.AssignedQty || 0,
          ExecutionsAvgPrice: currentDayData.ExecutionsAvgPrice || 0,
          ExecutionsAvgFX: currentDayData.ExecutionsAvgFX || 0,
          Status: currentDayData.Status || "New",
        }
      : {
          AssignedQty: 0,
          ExecutionsAvgPrice: 0,
          ExecutionsAvgFX: 0,
          Status: "New",
        };

    const currentDayIsReadOnly = currentDay.Status == "Booked";

    const isExistingAccount = order.Accounts
      ? !!order.Accounts.find((acc) => acc.index === account.index)
      : false;

    let modReadonly = {
      ...readonly,
      RequiresSpecialCustody: readonly.RequiresSpecialCustody || custodyReadonly,
      Markup: readonly.Markup || currentDayIsReadOnly,
      MarkupType: readonly.MarkupType || currentDayIsReadOnly,
      FXMarkup: readonly.FXMarkup || currentDayIsReadOnly,
      FXMarkupType: readonly.FXMarkupType || currentDayIsReadOnly,
      Commission: readonly.Commission || currentDayIsReadOnly,
      CommissionType: readonly.CommissionType || currentDayIsReadOnly,
      AccountName: readonly.AccountName || isExistingAccount,
      differCommissionPayment: readonly.differCommissionPayment || currentDayIsReadOnly,
    };

    const userIsOwner =
      !AccountType ||
      AccountType == "" ||
      (userType == UserType.Trader && AccountType != "Customer") ||
      (userType == UserType.Advisor && AccountType == "Customer");

    if (!userIsOwner) {
      Object.keys(order.CurrentAccount).forEach((key) => {
        modReadonly[key] = true;
      });
    }

    let canResend = false;
    if (order.canResendAuthorizations) {
      if (account.Instruction === "ViaLink") {
        canResend = true;
      }
    }

    const isProp =
      account.AccountId && this.state.ownPositionAccounts.find((accountId) => accountId == account.AccountId);

    const hideHolders = this.state.holders !== null && this.state.holders.length == 0 && !isProp;

    let quantities = [];
    let quantityTitle = <span>Quantity</span>;
    let markupTitle = <span>{`Mark ${order.OrderSide == "Buy" ? "Up" : "Down"}`}</span>;
    let FXMarkupTitle = <span>{`FX Mark ${order.OrderSide == "Buy" ? "Up" : "Down"}`}</span>;
    let commissionTitle = <span>Commission</span>;
    let differCommissionPaymentTitle = <span>Differ Commission Payment</span>;
    let isPartiallyBooked = false;
    if (account.Day) {
      quantities = account.Day.map((day) => {
        if (day.Status == "Booked") {
          // If account is booked at least for one day, then:
          // - We can't change the account.
          isPartiallyBooked = true;
        }
        return {
          date: day.Date,
          status: day.Status,
          quantity: parseFloat(day.AssignedQty),
          markup: parseFloat(day.Markup),
          markupType: day.MarkupType == ComType.FaceValueCash ? "$ Cash" : "% Principal",
          FXMarkup: parseFloat(day.FXMarkup),
          FXMarkupType: day.FXMarkupType == ComType.FaceValueCash ? "$ Cash" : "% Principal",
          commission: parseFloat(day.Commission),
          commissionType: day.CommissionType == ComType.FaceValueCash ? "$ Cash" : "% Principal",
        };
      });
    }
    quantityTitle = (
      <Fragment>
        <span>Quantity</span>
        {quantities.length > 0 && OrderId > 0 && (
          <QuantityHelper quantities={quantities} name="account">
            <i className="icon-info icons" />
          </QuantityHelper>
        )}
      </Fragment>
    );
    markupTitle = (
      <Fragment>
        <span>{`Mark ${order.OrderSide == "Buy" ? "Up" : "Down"}`}</span>
        {quantities.length > 0 && OrderId > 0 && (
          <EarningsHelper quantities={quantities} earningCategoryName="markup" earningTypeName="markupType">
            <i className="icon-info icons" />
          </EarningsHelper>
        )}
      </Fragment>
    );
    FXMarkupTitle = (
      <Fragment>
        <span>{`FX Mark ${order.OrderSide == "Buy" ? "Up" : "Down"}`}</span>
        {quantities.length > 0 && OrderId > 0 && (
          <EarningsHelper
            quantities={quantities}
            earningCategoryName="FXMarkup"
            earningTypeName="FXMarkupType"
          >
            <i className="icon-info icons" />
          </EarningsHelper>
        )}
      </Fragment>
    );
    commissionTitle = (
      <Fragment>
        <span>Commission</span>
        {quantities.length > 0 && (
          <EarningsHelper
            quantities={quantities}
            earningCategoryName="commission"
            earningTypeName="commissionType"
          >
            <i className="icon-info icons" />
          </EarningsHelper>
        )}
      </Fragment>
    );
    differCommissionPaymentTitle = (
      <Fragment>
        <span>Differ Commission Payment</span>
      </Fragment>
    );

    if (isPartiallyBooked) {
      modReadonly = {
        ...modReadonly,
        AccountName: true,
        HolderName: true,
        Instruction: true,
        RequiresSpecialCustody: true,
        Quantity: true,
      };
    }

    const inputProps = {
      placeholder: "Account",
      disabled: modReadonly.AccountName,
      invalid: !!errors.AccountName,
    };

    const hasDifferentCurrencies = OrderCurrencySymbol !== OrderSettlementCurrencySymbol;

    const earningsTitle = `Values for ${CurrentInfoDate} (Q: ${formattedNumber(
      currentDay.AssignedQty,
      "quantity"
    )}; P: ${formattedNumber(currentDay.ExecutionsAvgPrice, "price")}${
      hasDifferentCurrencies
        ? `; FX [${baseCurrency}/${priceCurrency}]: ${formattedNumber(
            currentDay.ExecutionsAvgFX,
            "currency"
          )}`
        : ""
    }):`;

    let defaultMaxDecimals = 2;
    switch (order.AssetClassForm) {
      case ProductType.BOND:
      case ProductType.EQUITY:
      case ProductType.OPTION:
        defaultMaxDecimals = 0;
        break;
      case ProductType.MFUNDS:
      case ProductType.MMARKET:
        defaultMaxDecimals = 5;
        break;
      case ProductType.FOREX:
        defaultMaxDecimals = 2;
        break;
      default:
        defaultMaxDecimals = 2;
    }

    const quantityMaxDecimals = OrderQuantityIsCash ? 2 : SubAssetClassDecimalPlaces || defaultMaxDecimals;

    const showClientPrice =
      [OrderPriceType.LIMIT, OrderPriceType.STOPLIMIT].includes(order.OrderType) ||
      currentDay.ExecutionsAvgPrice != 0;
    const showClientFX = hasDifferentCurrencies && currentDay.ExecutionsAvgFX != 0;

    const originalPrice =
      currentDay.ExecutionsAvgPrice != 0 ? currentDay.ExecutionsAvgPrice : order.OrderPrice;

    const originalFX = currentDay.ExecutionsAvgFX;

    return (
      <div>
        {/* ##### Quantity ###### */}
        {!modHiddens.Quantity && (
          <Field label={quantityTitle} error={errors.Quantity}>
            <Numeric
              value={Quantity}
              placeholder={"Quantity"}
              disabled={modReadonly.Quantity}
              onChange={(v) => onChange({ Quantity: v })}
              invalid={!!errors.Quantity}
              dataTypeDecimalName="quantity"
            />
          </Field>
        )}

        {/* ##### Account ###### */}
        <FormGroup>
          <Field label="Account" error={errors.AccountName}>
            <Autosuggest
              renderSuggestion={renderSuggestion}
              getSuggestionValue={getSuggestionValue}
              onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
              inputProps={inputProps}
              onChange={this.onChange}
              value={
                opsViewAccountName !== undefined ?
                (
                  opsViewAccountName ?
                  (
                    AccountNumber ? `${AccountNumber} - ${AccountName}` : ""
                  )
                  :
                  (
                    AccountNumber ? `${AccountNumber}` : ""
                  )
                )
                :
                (
                  AccountNumber ? `${AccountNumber} - ${AccountName}` : ""
                )
              }
            />
          </Field>
        </FormGroup>

        {this.state.loadingHolders ? (
          <CircularProgress sm />
        ) : (
          <div>
            {!hideHolders && !isProp && (
              <Field label="Holder" error={errors.HolderName}>
                <Holders
                  name={HolderName}
                  value={HolderId}
                  items={this.state.holders}
                  disabled={modReadonly.HolderName || modReadonly.AccountName}
                  invalid={!!errors.HolderName}
                  onChange={this.onChangeAccountHolder}
                />
              </Field>
            )}

            <ExternalAccountWrapper
              getAccountsService={this.props.getUserExternalAccounts}
              accounts={clientBankAccounts}
              logo={imgSource}
              selectedAccount={clientBankAccount}
              selectedCash={useCashAccount}
              onChange={this.onSelectedAccountChange}
              onCheckCashAccount={this.onCheckCashAccount}
              currencyISO={order.OrderCurrencySymbol}
              account={account}
              error={errors.clientBankAccounts}
              disabled={modReadonly.HolderName || modReadonly.AccountName}
              onChangeAvailableAccounts={this.onChangeAvailableAccounts}
            />

            {this.state.loadingBalance ? (
              <CircularProgress sm />
            ) : (
              balanceReady && this.state.balance != null && <Balance balance={this.state.balance} />
            )}
            {!hideHolders && (
              <Instruction
                value={account.Instruction}
                items={this.state.instructions}
                attachmentDisabled={attachmentDisabled}
                userType={userType}
                disabled={modReadonly.Instruction || HolderId == null}
                error={errors.Instruction}
                onChange={this.onChangeInstruction}
                onChangeOrder={onChange}
                setAttachment={this.onSetAttachment}
                downloadAttachment={downloadAttachment}
                orderId={OrderId}
                orderPdf={orderPdf}
                hasAttachment={hasAttachment}
                accountId={AccountId}
                canResend={canResend}
                hasFile={account.HasFile}
                onResendAuth={this.onResendAuth}
                sendingMail={this.state.sendingMail}
                isProp={isProp}
              />
            )}
          </div>
        )}
        {/* ##### Custody ###### */}
        {!modHiddens.RequiresSpecialCustody && (
          <Field>
            <Switch
              value={RequiresSpecialCustody || false}
              label={"Custody"}
              disabled={modReadonly.RequiresSpecialCustody}
              onChange={(v) => onChange({ RequiresSpecialCustody: v })}
            />
          </Field>
        )}

        {!(modHiddens.Markup && modHiddens.FXMarkup && modHiddens.Commission) && OrderId > 0 && (
          <div style={{ marginBottom: "10px" }}>
            <u>{earningsTitle}</u>
          </div>
        )}

        {!modHiddens.Markup && (
          <Fragment>
            <Row>
              {/* ##### Mark up/down ###### */}
              <Col lg={6}>
                <Field label={markupTitle} error={errors.Markup}>
                  <Numeric
                    value={Markup}
                    placeholder={`Mark ${order.OrderSide == "Buy" ? "Up" : "Down"}`}
                    disabled={modReadonly.Markup}
                    onChange={(v) => onChange({ Markup: v })}
                    invalid={!!errors.Markup}
                    {...commissionSuffix(MarkupType, order.OrderCurrencySymbol)}
                    dataTypeDecimalName="currency"
                  />
                </Field>
              </Col>

              {/* ##### Mark type ###### */}
              <Col lg={6}>
                <Field label={"Type"} error={errors.MarkupType}>
                  <Combobox
                    value={MarkupType}
                    items={getCommissionItems(order.AssetClassForm)}
                    disabled={modReadonly.MarkupType}
                    onChange={(v) => onChange({ MarkupType: v })}
                    emptyLabel={"Type"}
                    invalid={!!errors.MarkupType}
                    style={{ background: "#edf9ff", fontWeight: 500 }}
                  />
                </Field>
              </Col>
            </Row>

            {/* ##### Client Price ###### */}
            {showClientPrice && !modHiddens.showClientPrice && (
              <Field label={"Client price"}>
                <Numeric
                  value={clientPrice(
                    order.OrderSide,
                    MarkupType,
                    Markup,
                    originalPrice,
                    AssetPriceIsDiscounted
                  )}
                  placeholder={"Client Price"}
                  onChange={(v) => null}
                  disabled
                  dataTypeDecimalName="price"
                />
              </Field>
            )}

            {/* #### FX Mark up/down #### */}
            {!modHiddens.FXMarkup && readonly.FXMarkupAllowed && (
              <Row>
                <Col lg={6}>
                  <Field label={FXMarkupTitle} error={errors.FXMarkup}>
                    <Numeric
                      value={FXMarkup}
                      placeholder={`FX Mark ${order.OrderSide == "Buy" ? "Up" : "Down"}`}
                      disabled={modReadonly.FXMarkup}
                      onChange={(v) => onChange({ FXMarkup: v })}
                      invalid={!!errors.FXMarkup}
                      {...commissionSuffix(FXMarkupType, `${baseCurrency}/${priceCurrency}`)}
                      dataTypeDecimalName={
                        FXMarkupType == ComType.PrincipalPercentage ? "percenttage" : "default"
                      }
                    />
                  </Field>
                </Col>

                {/* ##### FX Mark type ###### */}
                <Col lg={6}>
                  <Field label={"Type"} error={errors.FXMarkupType}>
                    <Combobox
                      value={FXMarkupType}
                      items={getCommissionItems(order.AssetClassForm)}
                      disabled={modReadonly.FXMarkupType}
                      onChange={(v) => onChange({ FXMarkupType: v })}
                      emptyLabel={"Type"}
                      invalid={!!errors.FXMarkupType}
                      style={{ background: "#edf9ff", fontWeight: 500 }}
                    />
                  </Field>
                </Col>
              </Row>
            )}

            {/* ##### Client Price ###### */}
            {showClientFX && (
              <Field label={"Client FX"}>
                <Numeric
                  value={clientPrice(order.OrderSide, FXMarkupType, FXMarkup, originalFX, false)}
                  placeholder={"Client FX"}
                  onChange={(v) => null}
                  disabled
                  dataTypeDecimalName="currency"
                />
              </Field>
            )}
          </Fragment>
        )}

        {AssetClassForm == ProductType.REPO && (
          <Row>
            {/* ##### Term ###### */}
            <Col lg={12}>
              <Field label="Term" error={errors.OrderTerm}>
                <Numeric
                  value={OrderTerm}
                  placeholder={`Term`}
                  disabled={modReadonly.OrderTerm}
                  onChange={(v) => onChangeOrder({ OrderTerm: v })}
                  invalid={!!errors.OrderTerm}
                  dataTypeDecimalName="currency"
                />
              </Field>
            </Col>
          </Row>
        )}

        {!modHiddens.Commission && (
          <Row>
            {/* ##### Commission ###### */}
            <Col lg={6}>
              <Field label={commissionTitle} error={errors.Commission}>
                <Numeric
                  value={Commission}
                  placeholder={`Commission`}
                  disabled={modReadonly.Commission}
                  onChange={(v) => onChange({ Commission: v })}
                  invalid={!!errors.Commission}
                  {...commissionSuffix(CommissionType, order.OrderSettlementCurrencySymbol)}
                  dataTypeDecimalName="currency"
                />
              </Field>
            </Col>

            {/* ##### CommissionType ###### */}
            <Col lg={6}>
              <Field label={"Type"} error={errors.CommissionType}>
                <Combobox
                  value={CommissionType}
                  items={getCommissionItems(order.AssetClassForm)}
                  disabled={modReadonly.CommissionType}
                  invalid={!!errors.CommissionType}
                  onChange={(v) => {
                    onChange({ CommissionType: v });
                  }}
                  emptyLabel={"Type"}
                  style={{ background: "#edf9ff", fontWeight: 500 }}
                />
              </Field>
            </Col>
          </Row>
        )}
        {!modHiddens.DifferCommissionPayment && this.state.accountIsJuridical && this.state.isMainHolder && (
          <Row>
            <Col lg={6}>
              <Field label={differCommissionPaymentTitle}></Field>
            </Col>
            <Col>
              <CheckFormField
                name="differCommissionPayment"
                label=""
                disabled={modReadonly.differCommissionPayment}
                initialValue={differCommissionPayment || false}
                value={differCommissionPayment}
                onChange={(n, v) => {
                  onChange({ differCommissionPayment: v });
                }}
              />
            </Col>
          </Row>
        )}
        <Row>
          <Col>
            <Label
              className="switch switch-text switch-pill switch-secondary switch-lg"
              style={{ marginBottom: "0px" }}
            >
              <Input
                type="checkbox"
                className="switch-input"
                onChange={(e) => onChange({ Advice: e.target.checked })}
                defaultChecked={!!Advice}
                value={!!Advice}
              />
              <span className="switch-label" data-on="Yes" data-off="No"></span>
              <span className="switch-handle"></span>
            </Label>
            <Label
              style={{
                marginBottom: "5px",
                marginLeft: "5px",
                verticalAlign: "bottom",
              }}
            >
              Advice
            </Label>
          </Col>
        </Row>
      </div>
    );
  }
}

const defaultAccountValue = {
  AccountId: null,
  AccountName: "",
  HolderId: null,
  HolderName: null,
  Instruction: null,
  differCommissionPayment: false,
};

const renderSuggestion = (suggestion) => (
  <div className={styleF.suggestionItem}>
    {suggestion.number}
    {" - "}
    <span>{suggestion.name}</span>
  </div>
);

const getSuggestionValue = (suggestion) => `${suggestion.number} - ${suggestion.name}`;

const getInstructions = (holder, isBasket) => {
  const instructions = [];
  if (holder.HoldersOrderNO) instructions.push({ id: "Managed", description: "Managed" });
  else {
    if (holder.HoldersOrderW) instructions.push({ id: "Written", description: "Written" });
    if (holder.HoldersOrderV && !isBasket) instructions.push({ id: "Web", description: "Web" });
    if (holder.HoldersOrderL) instructions.push({ id: "ViaLink", description: "Via Link" });
  }

  return instructions;
};

const getItemById = (items, id) => items.find((e) => e.id === id);

const isEmpty = (value) => value === undefined || value === "";

export default Account;
